import { useState } from 'react';
import { GoChevronUp, GoChevronDown } from 'react-icons/go';

interface AccordionProps {
  children: JSX.Element;
  title: string;
  titleClassName?: string;
  isExpanded?: boolean;
  padding?: string;
  noFrame?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  children, title, isExpanded, titleClassName = 'text-lg font-medium mb-0 text-text-primary', noFrame, padding = 'p-3',
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const handleClick = () => {
    if (isExpanded) {
      return;
    }
    setExpanded((e) => !e);
  };

  const icon = expanded ? <GoChevronUp className='text-2xl' /> : <GoChevronDown className='text-2xl' />;

  return (
    <div className={` ${noFrame ? '' : 'glass-surface p-0'}`}>
      <div>
        <div className={'items-center cursor-pointer'}>
          <div
            onClick={() => handleClick()}
            className={`flex justify-between items-center ${padding}`}
          >
            <span className={`${titleClassName}`}>{title}</span>
            {icon}
          </div>
          <div className={`${padding} pt-0`} hidden={!expanded}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
